import { FormFields } from '../fields/FormFields';
import { FieldValidation } from './FormFieldValidationContext';

export const formFieldValidations = {
  [FormFields.firstName]: new FieldValidation(),
  [FormFields.lastName]: new FieldValidation(),
  [FormFields.email]: new FieldValidation(),
  [FormFields.reason]: new FieldValidation(),
  [FormFields.description]: new FieldValidation(),
  [FormFields.orderNumber]: new FieldValidation(),
  [FormFields.customerNumber]: new FieldValidation(),
  [FormFields.attachment]: new FieldValidation(),
};
